import { render, staticRenderFns } from "./ShapeControlHandle.vue?vue&type=template&id=ac6a5b0a"
import script from "./ShapeControlHandle.vue?vue&type=script&lang=js"
export * from "./ShapeControlHandle.vue?vue&type=script&lang=js"
import style0 from "./ShapeControlHandle.vue?vue&type=style&index=0&id=ac6a5b0a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports